import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head, HeadControls } from './files-management-page.styles';
import { Typography } from '@shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { ListFilesManagement } from '@widgets/list-files-management/ui/list-files-management';
import { FilterFilesManagement } from '@features/file/filter-files-management/ui/filter-files-management';
import { DEFAULT_FILES_LIST_PARAMETERS } from '@entities/file/config/api-constants';
import { useFilesListSharedQuery } from '@entities/file/libs/hooks/use-files-list-shared-query/use-files-list-shared-query';
import { CreateFile } from '@features/file/create-file/ui/create-file';
import { FilesListDataRequest } from '@shared/api/file/file-types';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const FilesManagementPage = () => {
    const [filesListParameters, setFilesListParameters] =
        useSearchParams<FilesListDataRequest>(DEFAULT_FILES_LIST_PARAMETERS);
    const [getFilesList] = useFilesListSharedQuery(filesListParameters);
    const history = useHistory();

    useEffect(() => {
        getFilesList(filesListParameters);
    }, [filesListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Typography size='h6'>Файлы</Typography>
                    <HeadControls>
                        <FilterFilesManagement
                            filesListParameters={filesListParameters}
                            setFilesListParameters={setFilesListParameters}
                        />
                        <CreateFile />
                    </HeadControls>
                </Head>
            </HeadWrapper>
            <ListFilesManagement
                filesListParameters={filesListParameters}
                setFilesListParameters={setFilesListParameters}
            />
        </Wrapper>
    );
};
